import React, { useState } from 'react';
import { useSelector } from 'react-redux';  // Importamos useSelector para obtener los datos del store
import { ToggleButton, ToggleButtonGroup, Checkbox } from '@mui/material';
import logo1 from '../../../assets/img/cdeicono.png';
import '../../../assets/styles/filtro-proyecto.css';

export default function WorkspaceBoard({ onProjectSelect }) {
  const DataInfo = useSelector(storeState => storeState.infoModulo.infoM);  // Obtenemos los datos de la base de datos
  const projects = DataInfo?.projectOptions || []; // Si no hay datos en statusOptions, se usa un arreglo vacío

  const [selectedProjects, setSelectedProjects] = useState([]);

  const handleToggleChange = (event, newSelectedProjects) => {
    setSelectedProjects(newSelectedProjects);
    onProjectSelect(newSelectedProjects.length === 0 ? null : newSelectedProjects);
  };

  const handleDeselectAll = () => {
    setSelectedProjects([]);
    onProjectSelect(null);
  };

  return (
    <div className="workspace-sidebar-header">
      <div className='workspace-sidebar-items'>
        <div className='workspace-select flex space-between align-center'>
          <div className='workspace-logo flex align-items'>
            <div
              style={{
                backgroundColor: '#2596be',
                borderRadius: '4px',
                width: '166px',
                padding: '1px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <img src={logo1} alt="Logo" className="Menu-logo" style={{ width: '60px' }} /> 
            </div>
          </div>
        </div>
      </div>
      <div className='workspace-select-container'>
        <div className='project-list-header'>
          <div className='project-list-title'>
            <h5>Proyectos:</h5>
            <span className='project-counter'>
              {selectedProjects.length} / {DataInfo?.projectOptions?.length || 0}
            </span>
          </div>
          <Checkbox
            checked={selectedProjects.length > 0}
            onChange={handleDeselectAll}
            disabled={selectedProjects.length === 0}
            color="primary"
            className="deselect-checkbox"
          />
        </div>
        <div style={{ maxHeight: '500px', overflowY: 'auto' }}> {/* Se agrega scroll */}
          <ToggleButtonGroup
            key={projects.id_proyecto + Math.random()}
            
            value={selectedProjects}
            onChange={handleToggleChange}
            aria-label="Project selection"
            orientation="vertical"
            style={{ width: '100%' }}
          >
            {DataInfo?.projectOptions?.map(project => (
              <ToggleButton
                key={project.id_proyecto}
                value={project.id_proyecto}
                className={selectedProjects.includes(project.id_proyecto) ? 'selected-button' : ''}
                style={{
                  backgroundColor: selectedProjects.includes(project.id_proyecto)
                    ? project.bgColor
                    : 'transparent',
                  color: selectedProjects.includes(project.id_proyecto)
                    ? project.fontColor
                    : '#000000',
                  border: `2px solid ${project.bgColor}`,
                  borderRadius: '3px',
                  margin: '2px',
                  marginLeft: -1,
                  textAlign: 'left',
                  display: 'block',
                  width: '200px',
                  transition: 'background-color 0.3s ease, border 0.1s ease',
                  fontSize: '13px',
                  fontWeight: 'bold',
                  height: '40px'
                }}
              >
                {project.nombre_proyecto}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </div>
      </div>
    </div>
  );
}
